import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import LineOfBusinessTab from './LineOfBusinessTab';
import { XsLineOfBusinessModal } from './XsLineOfBusinessModal';
import getTabSelected from '../../selectors/tabSelector';

export const LinesOfBusinessContainer = ({ enabledLOBs, isOverflowing, isVariant }) => {
  const lineOfBusiness = useSelector(getTabSelected);
  const isXsScreen = useMediaBreakpoint('xs-down');

  if (isXsScreen && isVariant) {
    return (
      <XsLineOfBusinessModal
        lineOfBusiness={lineOfBusiness}
      />
    );
  }
  return (
    <div className={`position-relative ${isVariant && 'hidden-xs-down'}`}>
      {enabledLOBs.map((lob) => (
        <LineOfBusinessTab
          key={`${lob}-tab-container`}
          lineOfBusiness={lob}
          shouldDisplayHeading={isOverflowing}
        />
      ))}
    </div>
  );
};
LinesOfBusinessContainer.propTypes = {
  enabledLOBs: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOverflowing: PropTypes.bool,
  isVariant: PropTypes.bool,
};

LinesOfBusinessContainer.defaultProps = {
  isOverflowing: false,
  isVariant: false,
};

export default LinesOfBusinessContainer;
